import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check, X, Printer } from "lucide-react";
import { EAP_COMPARISON } from "../../data/publicSite";
import usePageMeta from "../../lib/usePageMeta";

export default function ChaplaincyVsEap() {
  usePageMeta({
    title: "Chaplaincy vs. EAP: A 1-Page Comparison | California Corporate Chaplains",
    description: "A side-by-side comparison of workplace chaplaincy and traditional EAPs — for HR leaders, CHROs, CEOs, and boards.",
  });
  return (
    <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20" data-testid="chaplaincy-vs-eap">
      <Link to="/resources" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#4A6FA5] mb-8">
        <ArrowLeft className="w-4 h-4" /> All resources
      </Link>
      <p className="text-xs uppercase tracking-[0.2em] text-[#4A6FA5] font-semibold mb-2">Brief · For HR & People Leaders</p>
      <h1 className="font-heading text-3xl sm:text-4xl tracking-tight text-slate-900 leading-tight">Chaplaincy vs. EAP: A 1-Page Comparison Brief</h1>
      <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">A printable side-by-side overview HR leaders can share with CHROs, CEOs, and boards. Two genuinely different ways to support a workforce — the strongest organizations often invest in both.</p>
      <button onClick={() => window.print()} className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-slate-300 text-slate-700 text-sm font-medium hover:border-[#4A6FA5] hover:text-[#4A6FA5]"><Printer className="w-4 h-4" /> Print / Save as PDF</button>

      <div className="mt-10 overflow-x-auto rounded-2xl border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-[#F8FAFC]">
            <tr>
              <th className="text-left px-5 py-4 font-semibold text-slate-600 text-xs uppercase tracking-[0.16em]">Dimension</th>
              <th className="text-left px-5 py-4 font-semibold text-[#4A6FA5] text-xs uppercase tracking-[0.16em]">CCCHAPS Chaplaincy</th>
              <th className="text-left px-5 py-4 font-semibold text-slate-600 text-xs uppercase tracking-[0.16em]">Traditional EAP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {EAP_COMPARISON.map((row) => (
              <tr key={row[0]} className="hover:bg-slate-50/60">
                <td className="px-5 py-4 font-medium text-slate-900">{row[0]}</td>
                <td className="px-5 py-4 text-slate-700">{row[1]}</td>
                <td className="px-5 py-4 text-slate-600">{row[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-10 rounded-2xl bg-[#F0F4F8] border border-blue-100 p-6 md:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h3 className="font-heading text-lg font-medium text-slate-900">Want to talk through the differences with your team?</h3>
          <p className="text-sm text-slate-600 mt-1">Confidential consultation — no pitch, no obligation.</p>
        </div>
        <Link to="/schedule" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-[#4A6FA5] text-white font-medium hover:bg-[#3B597B] whitespace-nowrap">Request a Consultation <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </article>
  );
}
